import React from 'react'

export const SpinnerLoad = () => {
    return(
        <div className='w-full flex justify-center items-center animate-pulse'>
        <div className='w-12 h-12 bg-primary-dark flex flex-col justify-center items-center  rounded-full animate-spin'>
           <div className='w-8 h-12 bg-black  flex justify-center items-center rounded-full'>
                <div className='bg-white w-full h-9 rounded-full'>

                </div>
           </div>
        </div>
        </div>
    )
}